jQuery('.hero_image_slider_wrap').slick({
  dots: false,
  arrows: true,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
    prevArrow: "<div class='slick-prev'><img src='/wp-content/themes/DailyPress/assets/images/arrow_left.webp' class='a-left control-c' /></div>",
    nextArrow: "<div class='slick-next'><img src='/wp-content/themes/DailyPress/assets/images/arrow_right.webp' class='a-left control-c' /></div>",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});